"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useAppEventSubscription(selector) {
  const { item: appEventSubscription, ...rest } = useElement(
    WorkspaceElementType.AppEventSubscription,
    selector,
    (integrationApp) => selector ? integrationApp.appEventSubscription(selector) : void 0
  );
  return { appEventSubscription, ...rest };
}

export { useAppEventSubscription };
